import { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import parse from 'html-react-parser';
import './styles/home.css';

function Home({videoFrame, setVideoframe, settingCurrentPageForHeader}) {

    function videoFrameInit(code) {
        setVideoframe(true, code);
    }
    
    useEffect(()=> {
        settingCurrentPageForHeader("home");
    }, [settingCurrentPageForHeader]);

    const [homeState, setHomeState] = useState({
        pageContent : null,
        recordings : null,
        scores : null,
        articles : null,
        error : <p className="text-center">Ups! Błąd aplikacji</p>,
        status : false
    });

    const urls = useMemo(() => {
        return [
        '/api/home.json', 
        '/api/recordings.json', 
        '/api/scores.json', 
        '/api/articles.json'
    ]}, []);
    const promises = useMemo(() => { return [] }, []);
    const allData = useMemo(() => { return [] }, []);
    
    useEffect(() => {
        if(!homeState.status) {
            urls.map((item) => {
                promises.push(
                    axios.get(item)
                );
                return null;
            });
            Promise.all(urls).then(() => {
                promises.map((item, index) => {
                    item.then(value => {
                        allData[index] = value.data;
                    });
                    return null;
                });
                Promise.all(promises).then(() => {
                    setHomeState({
                        pageContent : allData[0],
                        recordings : allData[1],
                        scores : allData[2],
                        articles : allData[3].articles,
                        status : true
                    });
                    if(document.querySelector(".loading")) {
                        document.querySelector(".loading").remove();
                    }
                });
            })
        }
    }, [homeState, allData, promises, urls]);

    useEffect(()=> {
        if(homeState.status) {
            let currentHomeSlide = 0;
            const homeSlider = [...document.querySelectorAll(".home-slider-img")];
            setInterval(() => {
                let prevCurrentHomeSlide = currentHomeSlide;
                setTimeout(() => {
                    homeSlider[prevCurrentHomeSlide].classList.remove("anim");
                }, 900);
                homeSlider[currentHomeSlide].classList.remove("active");
                currentHomeSlide++;
                if(currentHomeSlide >= homeSlider.length) {
                    currentHomeSlide = 0;
                }
                homeSlider[currentHomeSlide].classList.add("active");
                homeSlider[currentHomeSlide].classList.add("anim");
            }, 5000);

            document.querySelector(".home-slider-arrow").addEventListener("click", () => {
                window.scrollTo({
                    top: window.innerHeight - document.querySelector("header").offsetHeight,
                    behavior: "smooth"
                });
            });
        }
    }, [homeState.status]);

    function newestVideos(data) {
        let videos = [];
        data.videos.slice(0,6).map((item, index) => {
            videos.push(
                <div className="card" key={index}>
                    <div className="card-box">
                        <img src={`https://i.ytimg.com/vi/${item.code}/mqdefault.jpg`} alt={item.title} />
                        <p>{parse(item.title)}</p>
                        <a href="/#" onClick={ (event) => {event.preventDefault();videoFrameInit(item.code);} }>{data.pageContent.watchText}</a>
                    </div>
                </div>
            );
            return null;
        });
        return videos;
    }

    function showScores(data) {
        let scores = [];
        function shuffleArr(array) {
            for (var i = array.length - 1; i > 0; i--) {
                var rand = Math.floor(Math.random() * (i + 1));
                [array[i], array[rand]] = [array[rand], array[i]]
            }
            return array;
        }
        shuffleArr(data.scores).slice(0,4).map((item, index) => {
            scores.push(
                <div className="home-notes-box" key={index}>
                    <div className="home-notes-mask">
                        <img src={data.pageContent.filesPath + item.img} alt={parse(item.title)} />
                        <div className="overlay"></div>
                    </div>
                    <div className="desc">
                        {parse(item.title)}<br />
                        {/* <span>
                            {item._embedded["wp:term"][0][0].acf.short_label}
                        </span> */}
                    </div>
                </div>
            );
            return null;
        });
        return scores;
    }

    function newestArticles(data) {
        let articles = [];
        data.slice(0,4).map((item, index) => {
            articles.push(
                <div className="article-box" key={index}>
                    <div className="article-inner-box">
                        <img src={item.img} alt={parse(item.title)} />
                        <h4>{parse(item.title)}</h4>
                        <Link to={`/artykuly/${item.id}/${item.slug}`}>{homeState.pageContent.articlesMore}</Link>
                    </div>
                </div>
            );
            return null;
        });
        return articles;
    }

    function showHomePage(data) {
        let homePageContent = null;
        if(data.status) {
            homePageContent = <>
                <div className="home-slider">
                    <div className="home-slider-img active anim" style={{ backgroundImage: 'url(' + data.pageContent.sliderPhoto1 + ')'}}></div>
                    <div className="home-slider-img" style={{ backgroundImage: 'url(' + data.pageContent.sliderPhoto2 + ')'}}></div>
                    <div className="home-slider-img" style={{ backgroundImage: 'url(' + data.pageContent.sliderPhoto3 + ')'}}></div>
                    <div className="home-slider-overlay"></div>
                    <div className="home-slider-psalm">
                        {data.pageContent.sliderTitle1}<br />
                        <span>{data.pageContent.sliderTitle2}</span>
                    </div>
                    <div className="home-slider-arrow"><img src="/img/arrow.svg" alt="To content" /></div>
                </div>
                <div className="standard-padding home-videos">
                    <div className="container">
                        <div className="home-videos-text">
                            <div>
                                <h2>
                                    {data.pageContent.recordingsTitle}
                                </h2>
                                {data.pageContent.recordingsDesc}
                            </div>
                            <div className="btn-container">
                                <Link to="/nagrania" className="btn">{data.pageContent.recordingsButton} <img src="/img/arrow.svg" alt=">" /></Link>
                            </div>
                        </div>
                        <div className="home-videos-boxes">
                            {newestVideos(data.recordings)}
                        </div>
                    </div>
                </div>
                <div className="standard-padding home-notes">
                    <div className="container">
                        <div>
                            <div className="home-notes-container">
                                {showScores(data.scores)}
                            </div>
                        </div>
                        <div>
                            <h2>
                                {data.pageContent.compositionsTitle}
                            </h2>
                            <p>{parse(data.pageContent.compositionsDesc)}</p>
                            <div className="btn-container text-center">
                                <Link to="/nuty" className="btn">{data.pageContent.compositionsButton} <img src="/img/arrow.svg" alt=">" /></Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="standard-padding home-articles">
                    <div className="container">
                        <h2>
                            {data.pageContent.articlesTitle}
                        </h2>
                        <div className="newest-articles">
                            {newestArticles(data.articles)}
                        </div>
                        <div className="text-center">
                            <Link to="/artykuly" className="btn">{data.pageContent.articlesButton} <img src="/img/arrow.svg" alt=">" /></Link>
                        </div>
                    </div>
                </div>
                <div className="home-library standard-padding" style={{backgroundImage: 'url(' + data.pageContent.libraryPhoto + ')'}}>
                    <div className="overlay"></div>
                    <div className="container">
                        <h2>
                            {data.pageContent.libraryTitle}
                        </h2>
                        {parse(data.pageContent.libraryDesc)}
                        <div className="btn-box">
                            <Link to="/biblioteka" className="btn">{data.pageContent.libraryButton} <img src="/img/arrow.svg" alt=">" /></Link>
                        </div>
                    </div>
                </div>
                </>
            ;
        } else {
            homePageContent = data.error;
        }
        return homePageContent;
    }

    return (
        <main>
            <div className="loading fullscreen-loading">
                <img src="/img/loader.png" alt="Wczytywanie..." />
            </div>
            {showHomePage(homeState)}
        </main>
    );
}

export default Home;